import { MyDigitsActionTypes } from "../actions/index.model";

export const logout = () => ({
  type: MyDigitsActionTypes.USER_LOGOUT,
});

export const getLineDetails = () => ({
  type: MyDigitsActionTypes.GET_LINE_DETAILS,
});

export const updateLineDetails = (data: any) => ({
  type: MyDigitsActionTypes.UPDATE_LINE_DETAILS,
  data,
});

export const filterLineDetails = (data: any) => ({
  type: MyDigitsActionTypes.FILTER_LINE_DETAILS,
  data,
});

export const updateUserInfo = (data: any) => ({
  type: MyDigitsActionTypes.UPDATE_USER_INFO,
  data,
});

export const updateGivenName = (data: any) => ({
  type: MyDigitsActionTypes.UPDATE_GIVEN_NAME,
  data,
});

export const setSelectedLine = (data: any) => ({
  type: MyDigitsActionTypes.SET_SELECTED_LINE,
  data,
});

export const resetLineDetails = () => ({
  type: MyDigitsActionTypes.RESET_LINE_DETAILS,
});

export const setAssignedLine = (data: any) => ({
  type: MyDigitsActionTypes.SET_ASSIGNED_LINE,
  data,
});

export const setUnAssignedLine = (data: any) => ({
  type: MyDigitsActionTypes.SET_UN_ASSIGNED_LINE,
  data,
});

export const resetAssigneeMsisdn = () => ({
  type: MyDigitsActionTypes.RESET_ASSIGNEE_MSISDN,
});

export const getLinePairDetails = (data: any) => ({
  type: MyDigitsActionTypes.GET_LINE_PAIR,
  data,
});

export const updatePairDetails = (data: any) => ({
  type: MyDigitsActionTypes.UPDATE_PAIR_LINE,
  data,
});

export const unpairLine = (data: any) => ({
  type: MyDigitsActionTypes.UNPAIR_LINE,
  data,
});

export const pairLine = (data: any) => ({
  type: MyDigitsActionTypes.PAIR_LINE,
  data,
});

export const selectedTab = (data: any) => ({
  type: MyDigitsActionTypes.CHNAGE_TAB,
  data,
});
